import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function OrderRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();

  useEffect(() => {
    if (authLoading) return;

    if (user) {
      // Authenticated user - go directly to order details
      navigate(`/order/${id}`, { replace: true });
    } else {
      // Guest user - redirect to order lookup with a message
      // Store the order ID in sessionStorage so we can pre-fill it
      if (id) {
        sessionStorage.setItem('pendingOrderLookup', id);
      }
      navigate('/guest-order-lookup', { 
        replace: true,
        state: { 
          message: 'Please verify your email to view order details',
          orderId: id 
        }
      });
    }
  }, [user, authLoading, id, navigate]);

  return (
    <div className="min-h-screen bg-brand-accent flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary mx-auto mb-4" />
        <p className="text-gray-600">Redirecting to your order...</p>
      </div>
    </div>
  );
} 